<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card class="text-xs-center pa-5 elevation-4">
                <img src="https://ashyaat.com/pub/media/logo/stores/1/logo.png" width="216" alt="">
              </v-card>
              <!-- <v-card-text class="text-xs-center">
                <v-form>
                  <v-text-field append-icon="person" name="email" label="Email" type="text" v-model="user.username"></v-text-field>
                  <v-text-field v-if="!forgetpass" append-icon="lock" name="password" label="Password" id="password" type="password" v-model="user.password"></v-text-field>
                </v-form>
                <span v-if="!forgetpass" class="error--text">{{ error }}</span>
                <span v-if="forgetpass" class="error--text">{{ resetStat }}</span>

              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <span v-if="!forgetpass" @click="forgetpass  = true" style="cursor:pointer" class="mx-2 blue--text">Forget password?</span>
                <span v-if="forgetpass" @click="forgetpass  = false" style="cursor:pointer" class="mx-2 blue--text">Sign in</span>
                <v-btn v-if="!forgetpass" block color="primary" @click="login" :loading="loading">Login</v-btn>
                <v-btn v-if="forgetpass" block color="primary" @click="resetPass" :loading="loading">Send Reset Email</v-btn>
              </v-card-actions> -->
              <v-divider class="my-3 mx-5"></v-divider>
              <v-flex xs12 my-1 class="text-xs-center">
                <span>Please Login Via:</span>
              </v-flex>
              <v-layout row wrap>
                <v-flex xs12 md12 my-3 class="text-xs-center">
                  <v-btn outline large color="#db4437" @click="OauthLogin(0)" dark>Google</v-btn>
                  <v-btn outline large color="#3b5998" @click="OauthLogin(1)" >Facebook</v-btn>

                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {firebase, db, auth} from '@/fb'

export default {
  data: () => ({
    loading: false,
    forgetpass:false,
    error:null,
    resetStat:null,
    user: {
      username: 'demo@me.io',
      password: '102030..'
    }
  }),

  methods: {
    goTo(path) {
      this.$router.push(path)
    },
    resetPass(){
      console.log(this.user.username)
      auth.sendPasswordResetEmail(this.user.username).then((data) => {
        this.resetStat = `Sent successfully to ${this.user.username}`
      }).catch((error) => {
        this.resetStat = error.message
      });
    },
    login () {
      this.loading = true;
      firebase.auth().signInWithEmailAndPassword(this.user.username, this.user.password).then(
          (resp) => {
            this.goTo('/')
          },
          (err) => {
            this.error = err.message
            this.loading = false;
          }
        );
    },
    OauthLogin (p) {
      var provider
      switch (p) {
        case 0:
          provider = new firebase.auth.GoogleAuthProvider();
          break;
        case 1:
          provider = new firebase.auth.FacebookAuthProvider();
          break;
        case 2:
          provider = new firebase.auth.TwitterAuthProvider();
          break;
        default:
          break;
      }
      firebase.auth().signInWithPopup(provider).then((result) => {
        this.goTo('/')
      }).catch((error) => {
        var errorMessage = error.message;
        this.error = error.message
      });
    }
  },
  created(){
    auth.onAuthStateChanged(user => {
      if (user) {
        this.goTo('/')
      }
    })
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
